import { Node, Vec3, _decorator } from 'cc';
import LocaleDataSet from '../../../I18n/LocaleDataSet';
import LocalizedComponent from './LocalizedComponent';
import SupportLanguage from '../../../I18n/SupportLanguage';

const { ccclass, property, menu } = _decorator;

@ccclass('LocalizedScale')
@menu('Internationalization/LocalizedScale')
export default class LocalizedScale extends LocalizedComponent<Node> implements LocaleDataSet<Vec3> {
    @property
    eng = Vec3.ONE.clone();
    @property
    sch = Vec3.ONE.clone();
    @property
    tch = Vec3.ONE.clone();
    @property
    hkt = Vec3.ONE.clone();
    @property
    ko = Vec3.ONE.clone();
    @property
    ja = Vec3.ONE.clone();
    @property
    id = Vec3.ONE.clone();
    @property
    pt = Vec3.ONE.clone();
    @property
    es = Vec3.ONE.clone();
    @property
    vi = Vec3.ONE.clone();
    @property
    th = Vec3.ONE.clone();
    @property
    ms = Vec3.ONE.clone();
    @property
    fil = Vec3.ONE.clone();
    @property
    hi = Vec3.ONE.clone();
    @property
    tr = Vec3.ONE.clone();
    @property
    ru = Vec3.ONE.clone();
    @property
    bn = Vec3.ONE.clone();
    @property
    my = Vec3.ONE.clone();
    @property
    de = Vec3.ONE.clone();

    protected getTarget(): Node {
        return this.node;
    }

    protected onLanguageChange(language?: SupportLanguage) {
        this.updateScale(language);
    }

    protected updateScale(language?: SupportLanguage) {
        this.target.setScale(this[language || this.i18n.currentLanguage]);
    }
}
